import styled from 'styled-components';

export const StyledSVG = styled.svg`
  transform: rotate(-45deg);
`;
